// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import { asyncStart } from '../../common/index';

export const GET_OUTCOMES_BONUS = 'outcomesBonus.getOutcomesBonus';
export const getOutcomesBonus = (gradYear) => (dispatch) => {
  dispatch(asyncStart(GET_OUTCOMES_BONUS));
  dispatch({
    type: GET_OUTCOMES_BONUS,
    gradYear,
  });
};

export const UPLOAD_OUTCOMES_BONUS_FILE = 'outcomesBonus.uploadFile';
// gradYear is the graduating class the user picked on the upload control. The TEA OB file
// is named by district (no year), so the user's choice is authoritative and overrides any
// year guessed from the file name.
export const uploadOutcomesBonusFile = (profile, file, gradYear) => (dispatch) => {
  dispatch(asyncStart(UPLOAD_OUTCOMES_BONUS_FILE));
  dispatch({
    type: UPLOAD_OUTCOMES_BONUS_FILE,
    profile,
    file,
    gradYear,
  });
};
